import React from 'react';
import Text from './Text';

export default class FormError extends React.PureComponent {
  render() {
    const { error } = this.props;

    return error ? (
      <Text.caption as="div" pt={3} color="dangerRed" data-testid="text-input-error">
        {error}
      </Text.caption>
    ) : null;
  }
}
